import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

/** Pole wymagane oznaczamy czerwoną gwiazdką (konwencja UX BillVis). */
export function Label({ className, required, children, ...props }: ComponentProps<'label'> & { required?: boolean }) {
  return (
    <label className={cn('text-sm font-medium leading-none text-foreground', className)} {...props}>
      {children}
      {required && <span className="ml-0.5 text-destructive">*</span>}
    </label>
  );
}
